import DIV from '../../DOM/div/DIV.js';
/** An Application User Component */
export default class USER extends DIV {
    constructor(node, model) {
        super(node, model);
        this.addClass('user');
    }
}
